import React from "react";
import styles from "./StatSection.module.scss";

type StatItem = {
	label: string;
	value: number | string | null | undefined;
	variant?: "positive" | "negative";
};

type StatSectionProps = {
	title: string;
	ticketCount: number | null | undefined;
	data: Array<StatItem>;
};

const StatSection: React.FC<StatSectionProps> = ({ title, ticketCount, data }) => {
	return (
		<div className={styles.statSection}>
			<div className={styles.header}>
				<h2>{title}</h2>
				<span className={styles.ticketCount}>{ticketCount} Tickets </span>
			</div>

			<div className={styles.dataRow}>
				{data.map((item, index) => (
					<div key={index} className={styles.dataItem}>
						<span className={styles.label}>{item.label}</span>
						<span data-color={item.variant} className={styles.value}>
							{item.value}
						</span>
					</div>
				))}
			</div>
		</div>
	);
};

export default StatSection;
